(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["email-signup-popup"]) return;
  try {
    
  (function () {
    var STORAGE_KEY = 'emailPopupDismissed';

    document.querySelectorAll('[data-email-popup]').forEach(function (overlay) {
      var box = overlay.querySelector('[data-email-popup-box]');
      var closeEls = overlay.querySelectorAll('[data-email-popup-close]');
      var form = overlay.querySelector('[data-email-popup-form]');
      var delay = parseInt(overlay.getAttribute('data-delay'), 10) || 5000;

      var alreadyDismissed = false;
      try {
        alreadyDismissed = sessionStorage.getItem(STORAGE_KEY) === '1';
      } catch (e) {}

      var justSubmitted = window.location.search.indexOf('customer_posted=true') !== -1;

      function showPopup() {
        overlay.classList.add('is-visible');
        overlay.setAttribute('aria-hidden', 'false');
      }

      function hidePopup() {
        overlay.classList.remove('is-visible');
        overlay.setAttribute('aria-hidden', 'true');
        try {
          sessionStorage.setItem(STORAGE_KEY, '1');
        } catch (e) {}
      }

      closeEls.forEach(function (el) {
        el.addEventListener('click', hidePopup);
      });

      overlay.addEventListener('click', function (e) {
        if (e.target === overlay) hidePopup();
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') hidePopup();
      });

      if (justSubmitted) {
        // Show immediately with the success message already rendered by Liquid.
        showPopup();
        try { sessionStorage.setItem(STORAGE_KEY, '1'); } catch (e) {}
      } else if (!alreadyDismissed) {
        setTimeout(showPopup, delay);
      }

      if (form) {
        form.addEventListener('submit', function () {
          try { sessionStorage.setItem(STORAGE_KEY, '1'); } catch (e) {}
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["om-tab-selection"] && !Shopify.designMode) return;
  try {
    

  function initOmTabSelection(root) {
    const sections = root.querySelectorAll
      ? root.querySelectorAll('.om-tab-selection')
      : [];

    sections.forEach((section) => {
      // Prevent double-binding if this runs more than once for the same section
      if (section.dataset.omTabInit === 'true') return;

      const tabs = Array.from(
        section.querySelectorAll('.om-tab-selection__tab')
      );

      const panels = Array.from(
        section.querySelectorAll('.om-tab-selection__panel')
      );

      if (!tabs.length || !panels.length) return;

      section.dataset.omTabInit = 'true';

      const activateTab = (selectedTab, moveFocus = false) => {
        tabs.forEach((tab) => {
          const isSelected = tab === selectedTab;

          tab.classList.toggle('is-active', isSelected);
          tab.setAttribute('aria-selected', isSelected ? 'true' : 'false');
          tab.setAttribute('tabindex', isSelected ? '0' : '-1');

          const panelId = tab.getAttribute('aria-controls');
          const panel = panelId
            ? section.querySelector(`#${CSS.escape(panelId)}`)
            : null;

          if (panel) {
            panel.hidden = !isSelected;
            panel.classList.toggle('is-active', isSelected);
          }
        });

        if (moveFocus) {
          selectedTab.focus();
        }
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', (event) => {
          event.preventDefault();
          activateTab(tab);
        });

        tab.addEventListener('keydown', (event) => {
          let nextIndex = null;

          if (event.key === 'ArrowRight') {
            nextIndex = (index + 1) % tabs.length;
          }

          if (event.key === 'ArrowLeft') {
            nextIndex = (index - 1 + tabs.length) % tabs.length;
          }

          if (event.key === 'Home') {
            nextIndex = 0;
          }

          if (event.key === 'End') {
            nextIndex = tabs.length - 1;
          }

          if (nextIndex !== null) {
            event.preventDefault();
            activateTab(tabs[nextIndex], true);
          }
        });
      });
    });
  }

  // Run once the DOM is ready (covers scripts that execute before markup exists)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initOmTabSelection(document));
  } else {
    initOmTabSelection(document);
  }

  // Re-init when this section is added/re-rendered in the theme editor
  document.addEventListener('shopify:section:load', (event) => {
    initOmTabSelection(event.target);
  });


  } catch(e) { console.error(e); }
})();
})();
